<!--
  El nombre accesible de cada ion-button va como texto oculto (.visually-hidden)
  y NO como [attr.aria-label]: Ionic 8.8 observa aria-label en ion-button y, si
  el atributo cambia antes de que el componente hidrate (el pipe translate pasa
  de la clave al texto traducido), el runtime de Stencil revienta con
  "Cannot read properties of undefined (reading 'onAriaChanged')".
-->
<ion-header [translucent]="false">
  <ion-toolbar class="main-header" [class.has-back]="showBackButton">
    @if (showBackButton) {
    <ion-buttons slot="start">
      <ion-button fill="clear" class="header-icon-btn" (click)="close()">
        <ion-icon slot="icon-only" name="arrow-back-outline" color="light" aria-hidden="true" />
        <span class="visually-hidden">{{ 'header.back' | translate }}</span>
      </ion-button>
    </ion-buttons>
    }

    <ion-title>
      @if (logoFor) {
      <!-- Pantallas raíz con barra inferior: el logo reemplaza al título (que repite la barra) y lleva al primer ítem. -->
      <button type="button" class="header-logo-btn" (click)="onLogoClick()">
        <img class="header-logo" src="assets/images/tqr-icon-white.svg" alt="" />
        <span class="visually-hidden">{{ 'header.logo' | translate }}</span>
      </button>
      <span class="visually-hidden">{{ title }}</span>
      } @else {
      <span class="header-title">{{ title }}</span>
      }
      @if (subtitle) {
      <span class="header-subtitle">{{ subtitle }}</span>
      }
    </ion-title>

    <ion-buttons slot="end">
      <!-- Lo que la pantalla quiera mostrar junto a las acciones (p.ej. el chip de rol del evento). -->
      <ng-content select="[headerChip]" />
      @if (showSearchIcon) {
      <ion-button (click)="onSearchClick()" fill="clear" class="header-icon-btn">
        <ion-icon slot="icon-only" name="search-outline" color="light" class="search-icon-flip" aria-hidden="true" />
        <span class="visually-hidden">{{ 'header.search' | translate }}</span>
      </ion-button>
      } @if (showFilterIcon) {
      <ion-button (click)="onFilterClick()" fill="clear" class="header-icon-btn">
        <ion-icon slot="icon-only" name="funnel-outline" color="light" aria-hidden="true" />
        <span class="visually-hidden">{{ 'header.filter' | translate }}</span>
      </ion-button>
      } @if (showHelpButton) {
      <ion-button (click)="onHelpClick()" fill="clear" class="header-icon-btn">
        <ion-icon slot="icon-only" name="help-circle-outline" color="light" aria-hidden="true" />
        <span class="visually-hidden">{{ 'header.help' | translate }}</span>
      </ion-button>
      } @if (showNotifications) {
      <ion-button (click)="onNotificationsClick()" fill="clear" class="notification-button header-icon-btn">
        <ion-icon slot="icon-only" name="notifications-outline" color="light" aria-hidden="true" />
        <span class="visually-hidden">{{ notificationsLabelKey() | translate: notificationsLabelParams() }}</span>
        @if (hasUnread()) {
        <!-- El conteo ya está en el nombre accesible; el badge es solo visual. -->
        <ion-badge class="notification-badge" [class.ios]="isIOS" aria-hidden="true">{{ badgeLabel() }}</ion-badge>
        }
      </ion-button>
      } @if (showAccount) {
      <ion-button fill="clear" class="header-icon-btn account-btn" (click)="openAccount()">
        @if (initials()) {
        <span class="header-avatar" aria-hidden="true">{{ initials() }}</span>
        } @else {
        <ion-icon slot="icon-only" name="person-circle-outline" color="light" aria-hidden="true" />
        }
        <span class="visually-hidden">{{ 'header.account' | translate }}</span>
      </ion-button>
      }
    </ion-buttons>
  </ion-toolbar>
</ion-header>
